// extracted by mini-css-extract-plugin
export var video = "VideoList-module--video--URh3G";